import http from '@/communication/AuthConnection'

export default async ({ state, commit }, payload) => {
  try {
    const result = await http.post(`/v1/item-pricing/update-dynamic-random-labs`, payload)
    return result.data
  } catch (e) {
    return Promise.reject(e)
  }
}



// WEBPACK FOOTER //
// ./src/brain/item-pricing/update-dynamic-random-labs/index.js